function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M88.6667 18.6667H74.6667V9.33337H65.3333V18.6667H46.6667V9.33337H37.3333V18.6667H23.3333C18.186 18.6667 14 22.8527 14 28V93.3334C14 98.4807 18.186 102.667 23.3333 102.667H88.6667C93.814 102.667 98 98.4807 98 93.3334V28C98 22.8527 93.814 18.6667 88.6667 18.6667ZM56 65.3334H32.6667V56H56V65.3334ZM79.3333 46.6667H32.6667V37.3334H79.3333V46.6667Z",
  fill: "white"
});

var SvgBxBxsNotepad = function SvgBxBxsNotepad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxBxsNotepad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bx_bxs-notepad.ff1f6b35.svg";
export { ForwardRef as ReactComponent };